var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionReserve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.75L9.16667 10.4167L12.9167 6.66667M16.6667 17.5V6.5C16.6667 5.09987 16.6667 4.3998 16.3942 3.86502C16.1545 3.39462 15.772 3.01217 15.3016 2.77248C14.7669 2.5 14.0668 2.5 12.6667 2.5H7.33333C5.9332 2.5 5.23314 2.5 4.69836 2.77248C4.22795 3.01217 3.8455 3.39462 3.60582 3.86502C3.33333 4.3998 3.33333 5.09987 3.33333 6.5V17.5L5.625 15.8333L7.70833 17.5L10 15.8333L12.2917 17.5L14.375 15.8333L16.6667 17.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionReserve);
export default __webpack_public_path__ + "static/media/action-reserve.69a5d80dca9b2e69983fa29b587c4ccf.svg";
export { ForwardRef as ReactComponent };